<template>
  <figure class="seal" :style="{ backgroundImage: 'url(/images/seal.svg)' }" />
</template>

<script>
export default {
  name: 'Seal'
}
</script>
